import { MenuItem } from '@mui/material';
import { useState, type FC, type ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';
import type { WithUser } from '../../context';
import { withUserContext } from '../../context';

const useStyles = makeStyles()(() => ({
  unlockStyle: {
    color: 'grey',
  },
}));

export interface MenuItemMouseOverProps extends WithUser {
  /**
   * Component is displayed when mouse hovers over a menu item
   * entry.
   */
  mouseOverObject: ReactNode;
  menuText: string;

  /**
   * Callback function is triggered when user has tickets for use
   * to unlock a locked sheet.
   */
  handleUnlockTranscription: () => void;
}

const MenuItemMouseOver: FC<MenuItemMouseOverProps> = ({
  mouseOverObject,
  menuText,
  handleUnlockTranscription,
}) => {
  const { classes } = useStyles();
  const [mouseOver, setMouseOver] = useState(false);

  const handleMouseOver = (isOver: boolean) => {
    setMouseOver(isOver);
  };

  return (
    <MenuItem
      component="a"
      className={classes.unlockStyle}
      onClick={handleUnlockTranscription}
      onMouseEnter={() => handleMouseOver(true)}
      onMouseLeave={() => handleMouseOver(false)}
    >
      {!mouseOver && menuText}
      {mouseOver && mouseOverObject}
    </MenuItem>
  );
};

export default withUserContext(MenuItemMouseOver);
